(function () {
    'use strict';

    /**
     *
     * @ngdoc service
     * @name adminCrewBatchers.service:CrewBatchService
     *
     * @description
     *
     */
    angular
        .module('configDistribution')
        .service('ConfigDistributionService', ConfigDistributionService);

    function ConfigDistributionService(ConfigDistributionFactory,RemoteService) {
        var self = this;
        var statusList = [
                {title:' All ', value: null},
                {title:' Active ', value: 'ACT'},
                {title:' Inactive ', value: 'INA'}
         ];

        self.searchCrewTypeMasterData = function(successFn, errorFn){
        	RemoteService.getCrewTypeList().then(
                  function (response) {
                	  var formatedList = ConfigDistributionFactory.formatCrewTypeResponse(response.crewTypeListDTOs);
                      successFn(formatedList);
                  },
                  function (error) {
                      errorFn(error.msg[0]);
                  }
              );
        }

        self.searchDistributionConfigGridData = function(crewTypes,postData,successFn, errorFn){
        	var request = ConfigDistributionFactory.populateGridDataSearchRequest(postData);
        	ConfigDistributionFactory.setCrewTypes(crewTypes);
        	ConfigDistributionFactory.setStatus(statusList);
        	RemoteService.searchDistributionConfigs(request).then(
                    function (response) {
                  	  var formatedList = ConfigDistributionFactory.formatGridDataSearchResponse(response.distributionConfigs);
                        successFn(formatedList,response.startPosition);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
             );
        }

        self.searchStatusOptions = function(){
        	return statusList;
        }

        self.getNewConfig = function(){
        	return ConfigDistributionFactory.getNewConfig();
        }

        self.formatSelectedRowData = function(rowData){
        	return ConfigDistributionFactory.formatSelectedRowData(rowData);
        }

        self.saveDistributionConfig = function(postdataArray,successFn,errorFn){
        	var request = ConfigDistributionFactory.populateUpdateConfigRequest(postdataArray);
        	RemoteService.saveDistributionConfig(request).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
            );
        }

        self.deleteDistributionConfig = function(postdata,successFn,errorFn){
        	var request = ConfigDistributionFactory.populateDeleteRequest(postdata);
        	RemoteService.deleteDistributionConfig(request).then(
                    function (response) {
                        successFn(response);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
            );
        }
        self.searchIdentifiers = function(successFn,errorFn){
        	RemoteService.searchDistributionConfigIdentifiers().then(
                    function (response) {
                        successFn(response.distributionIdentifierList);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
            );
        }

        self.searchActiveIdentifiers = function(successFn,errorFn){
          RemoteService.searchActiveDistributionConfigIdentifiers().then(
                    function (response) {
                      successFn(response.activeDistributionIdentifierList);
                    },
                    function (error) {
                      errorFn(error.msg[0]);
                    }
          );
        }

    }
})();
